import { FC } from "react";
import styled from "styled-components";

const TitleSpacing = styled.div`
	padding-left: 25px;
	padding-top: 25px;
	padding-bottom: 10px;
`;

const SubTitleWrapper = styled.div`
	width: 100%;
	font-family: Livvic;
	font-style: normal;
	font-weight: 600;
	font-size: 13px;
	text-align: left;
	line-height: 165.5%;
`;
export const SubTitle: FC = ({ children }) => {
	return (
		<TitleSpacing>
			<SubTitleWrapper>{children}</SubTitleWrapper>
		</TitleSpacing>
	);
};

const TitleWrapper = styled.div`
	width: 100%;
	font-family: Livvic;
	font-style: normal;
	font-weight: bold;
	font-size: 18px;
	text-align: left;
	line-height: 165.5%;
`;
export const Title: FC = ({ children }) => {
	return (
		<TitleSpacing>
			<TitleWrapper>{children}</TitleWrapper>
		</TitleSpacing>
	);
};
